var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConciliacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0331 2.4C16.4773 2.4 16.8375 2.75817 16.8375 3.2V6C16.8375 6.44183 16.4773 6.8 16.0331 6.8H13.2176C12.7734 6.8 12.4132 6.44183 12.4132 6C12.4132 5.55817 12.7734 5.2 13.2176 5.2H14.2568C13.1219 4.20361 11.6317 3.6 10 3.6C6.68811 3.6 3.95962 6.08878 3.60402 9.2879C3.55521 9.72705 3.15767 10.0437 2.7161 9.99516C2.27452 9.94661 1.95613 9.55125 2.00494 9.1121C2.44965 5.1113 5.85893 2 10 2C11.9966 2 13.823 2.72375 15.2287 3.92047V3.2C15.2287 2.75817 15.5888 2.4 16.0331 2.4Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2839 10.0048C17.7255 10.0534 18.0439 10.4487 17.9951 10.8879C17.5504 14.8887 14.1411 18 10 18C8.00343 18 6.17699 17.2763 4.77132 16.0795V16.8C4.77132 17.2418 4.41118 17.6 3.96691 17.6C3.52265 17.6 3.1625 17.2418 3.1625 16.8V14C3.1625 13.5582 3.52265 13.2 3.96691 13.2H6.78235C7.22662 13.2 7.58676 13.5582 7.58676 14C7.58676 14.4418 7.22662 14.8 6.78235 14.8H5.74319C6.87814 15.7964 8.36828 16.4 10 16.4C13.3119 16.4 16.0404 13.9112 16.396 10.7121C16.4448 10.2729 16.8423 9.9563 17.2839 10.0048Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConciliacion);
export default __webpack_public_path__ + "static/media/conciliacion.ee517968d55c12baefc28610b63a15c8.svg";
export { ForwardRef as ReactComponent };